<script>
  export let size = 30;
  export let color = "#aaaaaa";
</script>

<div
  class="spinner-wrap"
  style={`width: ${size}px; height: ${size}px; display: inline-block;`}
>
  <div
    class="spinner"
    style={`width: ${size}px; height: ${size}px; border-color: ${color}; border-radius: ${
      size / 2
    }px;`}
  />
</div>

<style>
  @keyframes spinner {
    to {
      transform: rotate(360deg);
      border-style: solid;
    }
  }

  .spinner {
    border-width: 3px;
    border-style: dashed;
    animation: 1s linear infinite spinner;
  }
</style>
